"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20ApprovalsProcessor = void 0;
var SimpleProcessor_1 = require("../common/SimpleProcessor");
var Erc20ApprovalDocumentBuilder_1 = require("./Erc20ApprovalDocumentBuilder");
var Erc20ApprovalsProcessor = /** @class */ (function () {
    function Erc20ApprovalsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.processor = new SimpleProcessor_1.SimpleProcessor(this.collectionNameBuilder, Erc20ApprovalDocumentBuilder_1.Erc20ApprovalDocumentBuilder.build);
    }
    Erc20ApprovalsProcessor.prototype.process = function (batch) {
        return this.processor.process(batch.erc20Approvals, batch);
    };
    return Erc20ApprovalsProcessor;
}());
exports.Erc20ApprovalsProcessor = Erc20ApprovalsProcessor;
//# sourceMappingURL=Erc20ApprovalsProcessor.js.map